import React from "react";
import AirdropComponent from "../../component/airdrop";
export function Airdrop() {
  return <AirdropComponent />;
}
